import { createBrowserClient } from '@supabase/ssr';

// Memoized so multiple call sites share auth state and Realtime channels.
// Safe in App Router: only client components reach this module.
let _client;

export function createClient() {
  if (!_client) {
    _client = createBrowserClient(
      process.env.NEXT_PUBLIC_OCTNE_SUPABASE_URL,
      process.env.NEXT_PUBLIC_OCTNE_SUPABASE_ANON_KEY,
    );
  }
  return _client;
}
